import { BusinessColId, BusinessColumnDef } from "constants/columnDefinitions";
import {
  ManualAdjustmentColId,
  ManualAdjustmentColumnDef,
} from "constants/columnDefinitions/manualAdjustment";

/**
 * We are displaying label reversed to what the data columns due to a shift to sundry templates.
 * This may be fixed one day??
 */

export const columnDefs = [
  ...Object.values(ManualAdjustmentColumnDef),
  {
    ...BusinessColumnDef[BusinessColId.NAME],
    colId: ManualAdjustmentColId.FROM_BUSINESS,
    field: "fromBusiness.name",
    headerName: "Paid To Business",
    cellRendererParams: {
      businessKey: "manualAdjustment.fromBusinessId",
    },
  },

  {
    ...BusinessColumnDef[BusinessColId.NAME],
    colId: ManualAdjustmentColId.TO_BUSINESS,
    field: "toBusiness.name",
    headerName: "Paid From Business",
    cellRendererParams: {
      businessKey: "manualAdjustment.toBusinessId",
    },
  },
];
